import React from 'react';
import Base from './Base';

type ButtonProps = React.ComponentProps<typeof Base>;

const Warning: React.FC<ButtonProps> = ({ className, ...rest }) => {
    const classes = ['btn--outline-warning', className].filter(Boolean).join(' ');
    return <Base className={classes} {...rest} />;
};

export default Warning;
